import { Component, input } from '@angular/core';

@Component({
  selector: 'app-spoiler',
  templateUrl: './sb-spoiler.component.html',
  styleUrls: ['./sb-spoiler.component.scss'],
  imports: []
})

/** Komponente zum Anzeigen von Spoiler-Nachrichten
 * Nachrichten oder Nachrichtenteile die gespoilert werden sollen,
 * werden "geblurred". Durch Anklicken wird diese wieder "revealed"
 * A_25395-03: "Instant Messaging" ist eine MUSS-Anforderung.
 * Laut Matrix Spezifikation fallen "Spoiler-Messages" in diese Kategorie
 */
export class SpoilerComponent {
  content = input.required<string>();
  preview = input.required<boolean>();
  unblurred = false;

  toggle(): void {
    if (!this.preview()) {
      this.unblurred = !this.unblurred;
    }
  }
}
